import { useEffect, useState } from "react"
import { collection, addDoc, getDocs, deleteDoc, doc, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase";
import { FaTrash } from "react-icons/fa";

const Admin = () => {
    const [blogs, setBlogs] = useState([]);
    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');

    const fetchBlogs = async () => {
        const querySnapshot = await getDocs(collection(db, 'blogs'));
        const blogsData = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
        setBlogs(blogsData);
        console.log(blogs)
    }
    const addBlog = async (e) => {
        e.preventDefault();
        if (title && content) {
            await addDoc(collection(db, 'blogs'), { title, content, createdAt: serverTimestamp(), });
            fetchBlogs();
            setTitle('');
            setContent('');
        }
    };
    const deleteBlog = async (id) => {
        await deleteDoc(doc(db, 'blogs', id));
        fetchBlogs();
    };
    useEffect(() => {
        fetchBlogs();
    }, [])

    return (
        <section className='max-w-screen-xl min-h-screen m-auto p-4'>
            <div className='flex justify-between'>
                <h1 className='font-[blanka] text-2xl text-secondary dark:text-primary'> <span className='text-white'>Admin</span> Dashboard</h1>
                <h1 className='font-[blanka] text-2xl text-secondary dark:text-primary'><span className='text-white'>Welcome</span> Mercy!</h1>
            </div>
            <form onSubmit={addBlog} className='text-lg my-10 mx-auto w-full flex flex-col gap-4 '>
                <div>
                    <label>Title:</label> <br />
                    <input
                        className='w-full p-2 rounded outline-none'
                        type="text"
                        placeholder='Blog title...'
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                    />
                </div>
                <div>
                    <label>Content:</label> <br />
                    <textarea
                        className='w-full h-52 resize-none p-2 rounded outline-none'
                        placeholder='Blog Description...'
                        value={content}
                        onChange={(e) => setContent(e.target.value)}
                    ></textarea>
                </div>
                <button className='w-full dark:bg-gradient-start bg-secondary p-2 text-white rounded'>Submit Blog</button>
            </form>

            <div>
                <h1 className="font-[blanka] dark:text-primary text-2xl">Blogs</h1>
                <div className="my-10 flex gap-5 flex-col">{blogs.map((blog) => (
                    <div className="md:flex items-center justify-between bg-white dark:text-white dark:bg-slate-600 p-5 rounded-3xl shadow-xl" key={blog.id} >
                        <div>
                            <h3 className="text-xl font-bold">{blog.title}</h3>
                            <p className="text-lg my-2">{blog.content}</p>
                            <p className="text-xs">Posted on: {new Date(blog.createdAt?.seconds * 1000).toLocaleString()}</p>
                        </div>
                        <button className="text-red-500 mt-2 rounded-full dark:bg-white bg-slate-700 p-3 shadow-xl" onClick={() => deleteBlog(blog.id)}> <FaTrash /></button>
                        
                    </div>
                ))}
                </div>
            </div>
        </section>
    )
}

export default Admin